import { type CSSProperties, useMemo } from 'react';

import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

import { Flex } from '../base';
import Spinner from '../Common/Spinner';
import CursorPagination from './CursorPagination';

type Props = {
  style?: CSSProperties;
  pageSize: number;
  total: number;
  current: number;
  currentLength: number;
  loading?: boolean;
  onChange: (page: number, pageSize?: number) => void;
};

const StyledPagination = (props: Props) => {
  const color = useColor();
  const startIndex = useMemo(() => {
    if (props.total === 0) return 0;
    return props.current * props.pageSize + 1;
  }, [props]);
  const endIndex = useMemo(() => {
    return startIndex + props.currentLength - 1;
  }, [props.currentLength, startIndex]);

  return (
    <Flex style={props.style} a="center" g="22px">
      <CursorPagination
        pageSize={props.pageSize}
        total={props.total}
        current={props.current + 1}
        onChange={(page) => props.onChange(page - 1)}
        disabled={props.loading}
      />
      <Typo style={{ color: color.gray500 }} type="label3">
        {startIndex} - {endIndex} of {props.total}
      </Typo>
      <Spinner status={!!props.loading} size={16} />
    </Flex>
  );
};

export default StyledPagination;
